import { pilot } from '~/services/serviceInstances';

type GetClientsParams = {
  clientId?: string;
};

export const deleteClient = async ({
  clientId,
}: GetClientsParams): Promise<boolean> => {
  const response = await pilot.remove(`client/${clientId}/`);

  return Boolean(response);
};
